<i class="fa fa-facebook font50"></i>
<h1 mat-dialog-title>{{dialogData.TittleText}}</h1>
<mat-dialog-content>
  {{dialogData.BodyText}}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCloseConfirm()" class="btn btn-primary">Ok</button>
</mat-dialog-actions>